import React, {useEffect, useState} from 'react';
import {getPopular, getRecent, home, likeStory} from "../../../api/requests";

import ErrorModal from "../../modals/ErrorModal";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Link from "next/link";
import Pagination from "../../pagination";
import {faHeart} from "@fortawesome/free-solid-svg-icons/faHeart";
import {scrollTop} from '../../backToTop/services'
import styles from "./ReadStories.module.scss"
import {useRouter} from "next/router";
import useTranslation from "next-translate/useTranslation";
import TokenError from "../../modals/tokenError";

const Stories = () => {
    const {t, lang} = useTranslation();
    const isRTL = lang === 'farsi';
    const [show, setShow] = useState();
    const [data, setData] = useState(null);
    const [newStoryData, setNewStoryData] = useState([]);
    const [selectedPage, setSelectedPage] = useState(0);
    const router = useRouter();
    const [newSelected, setNewSelected] = useState(0);
    const [pulse, setPulse] = useState({0: false, 1: false, 2: false, 3: false, 4: false, 5: false});
    const [filteredData, setFilteredData] = useState([]);
    const itemPerPage = 10;
    const [homeData, setHomeData] = useState(null);
    const [show2, setShow2] = useState(false);
    const toggle2 = () => setShow2(!show2);


    useEffect(() => {
        home().then(res => {
            let number;
            setHomeData(res.data);
            // console.log("res homeData",res.data)
        }).catch(err => console.log(err))
    },[])

    const handlePageClick = (selectedPage) => {
        setSelectedPage(selectedPage);
        if (data && data.recentStories) {
            let dt;
            const token = localStorage.getItem('token');

            if (show === "popular") {
                getPopular(token, selectedPage + 1)
                    .then(res => {
                            setData(prevState => ({...prevState, popularStories: res.data}));
                            dt = res.data.Stories;
                            setFilteredData(dt);
                        }
                    )
                    .catch(err => console.log("get popular stories error: ", err))
                setNewSelected(0)
            }
            if (show === "recent") {
                getRecent(token, selectedPage + 1)
                    .then(res => {
                            setData(prevState => ({...prevState, recentStories: res.data}));
                            dt = res.data.Stories;
                            setFilteredData(dt);
                        }
                    )
                    .catch(err => console.log("get recent stories error: ", err))
                setNewSelected(0)
            }
        }
        scrollTop();
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        getPopularStories(token, 1);
        getRecentStories(token, 1);
    }, [])
    const getPopularStories = (token, page) => {
        getPopular(token, page)
            .then(res => {
                setData(prevState => ({...prevState, popularStories: res.data}));
                setFilteredData(res.data.Stories)
                }
            )
            .catch(err => console.log("get popular and recent stories error: ", err))
    }
    const getRecentStories = (token, page) => {
        getRecent(token, page)
            .then(res => {
                setData(prevState => ({...prevState, recentStories: res.data}));
                    setShow("recent")
                    setFilteredData(res.data.Stories)
                }
            )
            .catch(err => console.log("get popular and recent stories error: ", err))
    }
    // console.log("data",data);
    // console.log("show",show);
    const currentPage=()=>{
        if (show==="recent" && data?.recentStories){
            return data.recentStories?.Pagination?.CurrentPage
        }else if(show==="popular" && data?.popularStories){
            return data.popularStories?.Pagination?.CurrentPage
        }
    }
    const submitLike = (e, StoryId) => {
        e.preventDefault();
        let token = localStorage.getItem('token');
        let Username = localStorage.getItem('Username');
        let page=currentPage();

        if (token && Username) {
            likeStory(StoryId, token)
                .then(res => {
                    if (show === "recent") {
                        getRecentStories(token, page)
                    }
                    if (show === "popular") {
                        getPopularStories(token, page)
                    }
                })
                .catch(err => {
                    if (err?.response?.status === 401 || err?.response?.status === 403) {
                        localStorage.setItem('token', '');
                        localStorage.setItem('Username', '');
                        localStorage.setItem('Counter', '');
                        localStorage.setItem('isLogin', '');
                        localStorage.setItem('CellPhoneNum', '');
                        setShow2(true);
                    }
                    else {
                        console.log("like error:", {err})
                    }
                })
        } else {
            setError(["login", false])
            setShowErrorModal(true)
        }
    }
    const numFormatter = (num) => {
        if (num > 999 && num < 1000000) {
            return (num / 1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million
        } else if (num > 1000000) {
            return (num / 1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million
        } else if (num < 900) {
            return num; // if value < 1000, nothing to do
        }
    }

    const [error, setError] = useState(null);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const toggle = () => setShowErrorModal(!showErrorModal);

    const getProfileImageSrc = (item) => {
        if (item && item.User?.ProfileImage && item.User.ProfileImage === 'img/head.png') {
            return '/images/table/profile.png'
        } else if (item && item.User?.ProfileImage && item.User.ProfileImage!==" ") {
            return item.User.ProfileImage
        } else {
            return '/images/table/profile.png'
        }
    }
    const wordCount = (str) => {
        str = str.replace(/(^\s*)|(\s*$)/gi, "");
        str = str.replace(/[ ]{2,}/gi, " ");
        str = str.replace(/\n /, "\n");
        let count = str.split(' ').length;
        return count;
    }

    // console.log('newSelected',newSelected)

    return (
        <div className={`${styles.wrapper}`}>
            <TokenError show={show2} toggle={toggle2} redirect={'wow-stories'}/>
            <ErrorModal error={error} show={showErrorModal} toggle={toggle} redirect={'wow-stories'}/>
            <div className={styles.title}>
                <h2 className={styles.storyTitle}>{t('readStories:wow-stories')}</h2>
            </div>

            <div className={styles.container}>
                <div className={styles.tab}>

                    <div onClick={() => setShow("recent")}
                         className={`${styles.tabItem} ${show === "recent" ? styles.active : ""}`}>{t('readStories:recent-stories')}
                    </div>
                    <div onClick={() => setShow("popular")}
                         className={`${styles.tabItem} ${show === "popular" ? styles.active : ""}`}>{t('readStories:popular-stories')}
                    </div>
                </div>
                <div className={styles.storyCardsWrapper}>
                    {filteredData && filteredData.map((item, i) => {
                        return (
                            <div className={styles.storyCard}>
                                <Link
                                    href={{
                                        pathname: `/wow-stories/${item.Id}`,
                                        // query: {name: item.user.Name + " " + item.user.Family},

                                    }}
                                >
                                    <a>
                                        <div className={styles.cardWrapper}>
                                            <h4 className={styles.cardTitle}>{item["Title"]}</h4>
                                            <div className={styles.story}>
                                                {item["RewritedText"]}
                                                {/*{newStoryData && newStoryData[i] && newStoryData[i].StoryContent}*/}
                                            </div>
                                        </div>
                                    </a>
                                </Link>
                                <div className={styles.footer}>
                                    <Link
                                        href={{
                                            pathname: `/profile/${item.User?.Counter}`,
                                            query: { name: item.User?.FullName},
                                        }}
                                    >
                                        <a>
                                    <img className={styles.profileImage}
                                        // src={` https://images.weserv.nl/?url=${item["profimage"]}`} alt=""/>
                                         src={getProfileImageSrc(item)}
                                        // src={item.profimage !== "0" ? item.profimage : '/images/table/profile.png'}
                                    />

                                        </a>
                                    </Link>

                                    <div className={styles.textWrapper}>
                                        <Link
                                            href={{
                                                pathname: `/profile/${item.User?.Counter}`,
                                                query: { name: item.User?.FullName},
                                            }}
                                        >
                                            <a href="">
                                        <p className={isRTL ? styles.userNameFa : styles.userNameEng}>{item.User.FullName}</p>
                                        </a></Link>
                                        <div className={styles.stats}>
                                            <p>{t('readStories:Score')}:
                                                {item.ReputationEffect ? numFormatter(item.ReputationEffect) : '-'}
                                            </p>
                                            <p>{t('readStories:Words')}:
                                                {item["RewritedText"] && wordCount(item["RewritedText"])}
                                            </p>
                                            <p className={styles.likes}
                                               onClick={(e) => submitLike(e, item.Id)}
                                               onMouseDown={() => {
                                                   setPulse(prevState => ({...prevState, [i]: true}))
                                               }
                                               }
                                               onMouseUp={() => setTimeout(() => {
                                                   setPulse(prevState => ({...prevState, [i]: false}))
                                               }, 1000)}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faHeart}
                                                    className={`${styles.likeIcon} ${styles.blob} ${pulse[i] ? styles.pulse : ''}${item.storyLiked ? styles.red : ''}`}
                                                />
                                                {numFormatter(item["UpVotes"])}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )

                    })}
                </div>
                {show === "popular" && <Pagination
                    newSelected={newSelected}
                    previousLabel={() => 'prev'}
                    nextLabel={() => 'next'}
                    pageCount={data?.popularStories?.Pagination?.TotalPages}
                    initialPage={1}
                    googlePaginate={true}
                    onPageChange={handlePageClick}
                />}
                {show === "recent" && <Pagination
                    newSelected={newSelected}
                    previousLabel={() => 'prev'}
                    nextLabel={() => 'next'}
                    pageCount={data?.recentStories?.Pagination?.TotalPages}
                    initialPage={1}
                    googlePaginate={true}
                    onPageChange={handlePageClick}
                />}

            </div>
            <div className={styles.bottomSection}>
                <h3 className={styles.text}>
                    {t('readStories:read')} {homeData?.TotalStories ? homeData.TotalStories : "685"} {t('readStories:read-write')}
                </h3>
                <button onClick={() => {
                    router.push('/wow-stories/getReady');
                }} className={styles.actionButton}>
                    {t('readStories:write-your-story')}
                </button>
            </div>

        </div>
    );
};

export default Stories;